export const UrlQuery = {
  /**
   * Query used on PDP.
   * When this query is assigned, PDP personazation should use multiple segmentation from pet profile
   * */
  multiSegmentMode: 'msm',
  /**
   * Hides the dynamic bundle on the dog home flow when set to `db=0`.
   * Campaign landings carry it in the URL; not persisted.
   */
  hideDynamicBundle: 'db',
} as const;

export type UrlQuery = (typeof UrlQuery)[keyof typeof UrlQuery];

/**
 * Value of the `db` URL param that hides the dynamic bundle.
 * Mirrors the named-flag convention of `EDIT_MODE` / `SKIP_GUIDE`.
 */
export const DYNAMIC_BUNDLE = {
  HIDE: '0',
} as const;
